import { apiRequest } from '@/utils/api-request';

interface EnhanceContentRequest {
  workflow_name: string;
  workflow_description: string;
  node_type: string;
  node_name: string;
  user_query: string;
  orgid: string;
}

interface EnhanceContentResponse {
  enhanced_query: string;
}

export const enhancePrompt = async (
  request: EnhanceContentRequest,
): Promise<{ data?: EnhanceContentResponse; detail?: string }> => {
  const response = await apiRequest<EnhanceContentResponse>({
    url: `/enhance-content/node`,
    method: 'POST',
    target: 'workflow',
    body: {
      workflow_name: request.workflow_name,
      workflow_description: request.workflow_description,
      node_type: request.node_type,
      node_name: request.node_name,
      user_query: request.user_query,
      orgid: request.orgid,
    },
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to enhance content' };
  }

  return response;
};
